import { ChangeEvent, FC } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Hooks
import { IConfig, Direction } from 'hooks/useSortableItems';
// Components
import Sidebar from 'components/Sidebar';
import { Select } from 'components/Controls';

type Props = {
  sortConfig: IConfig;
  onRequestSort: (key:string, direction:Direction) => void;
}

const QuizzesSortSidebar:FC<Props> = ({ sortConfig, onRequestSort }) => {
  const { t } = useTranslation();

  const handleChange = (event:ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = event.target;
    const key = name === 'key' ? value : sortConfig.key;
    const direction = name === 'key' ? sortConfig.key : value;
    onRequestSort(key, direction as Direction);
  }

  const directionOptions = (Object.keys(Direction) as Array<keyof typeof Direction>).map((direction) => ({
    value: Direction[direction], label: direction
  }));

  return (
    <Sidebar>
      <Select
        label={t('labels.sortBy')} id="sortBy" name="key" value={sortConfig.key}
        onChange={handleChange}
        options={[
          { value: 'name', label: t('labels.name') },
          { value: 'organization', label: t('labels.organization') },
          { value: 'startDate', label: t('labels.startDate') },
          { value: 'endDate', label: t('labels.endDate') }
        ]}
      />
      <Select
        label={t('labels.direction')} id="direction" name="direction" value={sortConfig.direction}
        onChange={handleChange}
        options={directionOptions}
      />
    </Sidebar>
  )
}

export default QuizzesSortSidebar;
